import { createSlice } from "@reduxjs/toolkit";

const data = {
    tiposContactos: [{ id: 0, descripcion: "" }],
    personaContactos: [{
        id: 0,
        idPersona: 0,
        numero: 0,
        idTipoContacto: 0,
        tipoContacto: "",
        valor: "",
        idEstado: 0,
        fechaRegistro: null,
        usuarioRegistro: null,
        fechaModificacion: null,
        usuarioModificacion: null,
    }],
}

export const personContactSlice = createSlice({
    name: "personContact",
    initialState: {},
    reducers: {
      initPersonContact: (state, action) => {
        const { sliceKey } = action.payload;
        if (!state[sliceKey]) state[sliceKey] = JSON.parse(JSON.stringify(data));
      },
      setTiposContactos: (state, action) => {
        const { sliceKey, data } = action.payload;
        state[sliceKey].tiposContactos = data;
      },
      setPersonaContactos: (state, action) => {
        const { sliceKey, data } = action.payload;
        state[sliceKey].personaContactos = data;
      },
      setDatoPersonaContacto: (state, action) => {
        var { sliceKey, numero, name, value } = action.payload;

        if (name.startsWith("id")) value = parseInt(value)
        
        const index = state[sliceKey].personaContactos.findIndex(item => item.numero === numero);
        state[sliceKey].personaContactos[index][name] = value;
      },
      addPersonaContacto: (state, action) => {
        const sliceKey = action.payload;
        var maxNumero = state[sliceKey].personaContactos.length === 0 ? 0 : Math.max.apply(null, state[sliceKey].personaContactos.map((item) => { return item.numero; }))

        state[sliceKey].personaContactos.push(defaultPersonaContactos.map((item) => { return { ...item, numero: maxNumero + 1 } })[0]);
      },
      removePersonaContacto: (state, action) => {
        const {sliceKey, numero} = action.payload;
        state[sliceKey].personaContactos = state[sliceKey].personaContactos.filter(item => item.numero !== numero)
      },

    },
});

export const { initPersonContact, setTiposContactos, setPersonaContactos, setDatoPersonaContacto
  , addPersonaContacto, removePersonaContacto } = personContactSlice.actions;
export const defaultPersonaContactos = [{
  id: 0,
  idPersona: 0,
  numero: 0,
  idTipoContacto: 69,
  tipoContacto: "Celular",
  valor: "",
  idEstado: 0,
  fechaRegistro: null,
  usuarioRegistro: null,
  fechaModificacion: null,
  usuarioModificacion: null,
}]
export default personContactSlice.reducer;
